// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const components: Record<string, any> = {};

export async function loadComponents() {
  components['leadsAttribute'] = (
    await import(
      '../plugins/leads/components/lead-attributes/lead-attributes.component'
    )
  ).LeadAttributesComponent;

  components['leadsAttributeToggle'] = (
    await import(
      '../plugins/leads/components/lead-attributes-toggle/lead-attributes-toggle.component'
    )
  ).LeadAttributesToggleComponent;

  // Load more components as needed
  // components[anotherComponent] = (await import('../path/to/another/component')).default;
}
